import React, { useMemo, useState } from "react";
import PermissionButton from "../../shared/PermissionButton";
import MarksAssessmentForm from "./MarksAssessmentForm";
import { useAssessmentType } from "../../../hooks/useAssessmentScale";
import LevelsAssessmentScale from "./LevelsAssessmentScale";
import GradeAssessmentScale from "./GradeAssessmentScale";
import Select from "../../shared/Select";

const CreateAssessmentScale = ({ name }) => {
  const { assessmentType } = useAssessmentType();
  const [scaleType, setScaleType] = useState("sct-mrk");

  const assessmentTypeOption = useMemo(() => {
    return assessmentType.map((item) => ({
      label: item.name,
      value: item.code,
    }));
  }, [assessmentType]);

  //generate grades A, A-, A+
  const gradeSelectOptions = useMemo(() => {
    const grades = [];

    for (let i = 0; i < 26; i++) {
      const letter = String.fromCharCode(65 + i);
      grades.push(letter, `${letter}+`, `${letter}-`);
    }

    return grades.map((g) => ({
      label: g,
      value: g,
    }));
  }, []);

  return (
    <>
      <div className="arr-content">
        <div className="arr-heading">
          <h1>Create Assessment Scale</h1>
          <div className="arr-btns-group">
            <PermissionButton
              moduleName={"Recording Setup"}
              widgetName={name}
              header={"Create Assessment Scale"}
              activityName={"insert-assessment-scale"}
            />
          </div>
        </div>

        <div
          style={{ marginBottom: "24px", width: "fit-content" }}
          className="arr-form"
        >
          <div className="form-input">
            <label htmlFor="scaleType">Scale Type</label>
            <Select
              name={"scaleType"}
              options={assessmentTypeOption}
              value={
                assessmentTypeOption.find((opt) => opt.value === scaleType) ||
                null
              }
              styles={{
                control: {width: "360px" },
              }}
              onChange={(option) => setScaleType(option?.value)}
              isClearable={false}
            />
          </div>
        </div>

        <div className="assessment-scale-form-container">
          <form>
            {scaleType === "sct-mrk" && (
              <MarksAssessmentForm scaleType={scaleType} type={"create"} />
            )}

            {scaleType === "sct-lvl" && (
              <LevelsAssessmentScale
                type={"create"}
                scaleType={scaleType}
                gradeSelectOptions={gradeSelectOptions}
              />
            )}

            {scaleType === "sct-grd" && (
              <GradeAssessmentScale
                type={"create"}
                scaleType={scaleType}
                gradeSelectOptions={gradeSelectOptions}
              />
            )}
          </form>
        </div>
      </div>
    </>
  );
};

export default CreateAssessmentScale;
